import { render, staticRenderFns } from "./RsvpSelection.vue?vue&type=template&id=53799e2c"
import script from "./RsvpSelection.vue?vue&type=script&lang=js"
export * from "./RsvpSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports